import React from "react";
import { Box, Typography } from "@mui/material";
import { SelectAppDataProps } from "../../../../Types/Workflow-Types";
import SettingItem from "../Shared/SettingItem";
import OutputSettingText from "../Shared/OutputSettingText";
import InfoItem from "../Shared/InfoItem";
import WorkflowSettingTabs from "../Shared/WorkflowSettingTabs";
const TextExtractionSetting = ({
  isFirstStep,
  readOnly,
  canShow,
}: SelectAppDataProps) => {
  const [value, setValue] = React.useState(0);
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  return (
    canShow ? 
    !readOnly?(
      <Box className="w-100 d-flex flex-column justify-content-center">
        <Box
          sx={{
            flexGrow: 1,
            justifyContent: "space-between",
            display: "flex",
            gap: "8px",
            height: 260,
          }}
        >
          <WorkflowSettingTabs value={value} handleChange={handleChange} />
          <SettingItem value={value} index={0}>
            <InfoItem
              header="Image"
              inputText={
                !isFirstStep
                  ? "Image will be added from the previous step."
                  : "Image will be added at runtime."
              }
            />
          </SettingItem>
          <SettingItem value={value} index={1}>
            <Box className="w-100">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography variant="body2" sx={{ mt: 1 ,textAlign:"left"}}>
                  Text Extractor has no settings.
                </Typography>
              </Box>
            </Box>
          </SettingItem>
          <SettingItem value={value} index={2}>
            <OutputSettingText  readOnly={readOnly}/>
          </SettingItem>
        </Box>
      </Box>
    ):(
       <Box className="w-100 d-flex flex-column justify-content-center">
        <ul className="w-100 workflow-list-readOnly">
          {/* input Type */}
          <li className="w-100 workflow-list-item-readOnly">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Typography>Input type:</Typography>
              <Typography
                sx={{
                  fontFamily: "Roboto",
                  fontWeight: "400",
                  fontSize: "14px",
                  lineHeight: "25px",
                  letterSpacing: "0.1px",
                  textDecoration: "underline",
                  color: "var(--Main_icons_color)",
                  opacity: "0.7",
                  textAlign: "start"
                }}
              >
                {!isFirstStep
                  ? "Image will be added from the previous step."
                  : "Image will be added at runtime."}
              </Typography>
            </Box>
          </li>
          {/* settings */}
          <li className="w-100 workflow-list-item-readOnly">
            <Box
              sx={{
                display: "flex",
                alignItems: "flex-start",
                justifyContent: "space-between",
                flexDirection: "column",
              }}
            >
              <Typography>Settings:</Typography>
              <Box className="container-workflow-setting-redaOnly">
                <Box
                  className="workflow-parameter-item-readOnly"
                >
                  <Typography className="paramter-value-setting">
                    Text Extraction has no settings.
                  </Typography>
                </Box>
              </Box>
            </Box>
          </li>
          {/* output Type */}
          <li className="w-100 workflow-list-item-readOnly">
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                flexWrap: "wrap",
              }}
            >
              <Typography>Output type:</Typography>
              <OutputSettingText readOnly={readOnly} />
            </Box>
          </li>
        </ul>
      </Box>
    ):null
  );
};

export default TextExtractionSetting;
